// extracted by mini-css-extract-plugin
export var root = "Q_xG";
export var wrapper = "Q_xH";
export var image = "Q_xJ d_w d_y d_W";
export var imageWithHeight = "Q_xK";
export var crop = "Q_xL";
export var round = "Q_xM";
export var fixedHeight = "Q_xN";